<mat-card>{{'categories' | translate}}</mat-card>


<div align="end" class="row" style="padding:10px;">
    <!-- <span class="spacer"></span> -->

    <button mat-raised-button color="primary" (click)="createNew()">
        <mat-icon>add</mat-icon>
        {{'create' | translate}}
    </button>
</div>

<div class="container" style="padding: 25px;">

    <mat-grid-list cols="4" rowHeight="50px">
        <mat-grid-tile cols="2">
            <mat-form-field appearance="standard">
                <mat-label>{{'filter' | translate}}</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
            </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile></mat-grid-tile>
        <mat-grid-tile></mat-grid-tile>

    </mat-grid-list>

    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'id' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
            </ng-container>

            <ng-container matColumnDef="fromAmount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'fromAmount' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.fromAmount}} </td>
            </ng-container>

            <ng-container matColumnDef="toAmount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'toAmount' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.toAmount}} </td>
            </ng-container>

            <ng-container matColumnDef="commission">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'commission' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.commission}} </td>
            </ng-container>

            <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef> {{'edit' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button (click)="edit(row)">
                        <mat-icon>edit</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef> {{'delete' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button (click)="onDelete(row.id)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}} "{{input.value}}"</td>
            </tr>
        </table>

        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

</div>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>

<ng-template #Modal>

    <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
    <div mat-dialog-content>
        <p>{{'areYouSureToDelete' | translate}}</p>

    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <button mat-button cdkFocusInitial (click)="confirmDelete()">{{'yes' | translate}}</button>
    </div>

</ng-template>

<ng-template #ModalAddUpdate>

    <h1 mat-dialog-title>{{!updateMode ? ('create' | translate) : ('update' | translate) }}</h1>
    <div mat-dialog-content>


        <mat-form-field appearance="standard">
            <mat-label>{{'fromAmount' | translate}}</mat-label>
            <input matInput [(ngModel)]="qrCategory.fromAmount" type="number">
        </mat-form-field>

        <mat-form-field appearance="standard">
            <mat-label>{{'toAmount' | translate}}</mat-label>
            <input matInput [(ngModel)]="qrCategory.toAmount" type="number">
        </mat-form-field>

        <mat-form-field appearance="standard">
            <mat-label>{{'commission' | translate}}</mat-label>
            <input matInput [(ngModel)]="qrCategory.commission" type="number">
        </mat-form-field>

    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <button mat-raised-button color="primary" (click)="save()">{{'submit' | translate}}</button>
    </div>

</ng-template>